import styled from 'styled-components';

import { Separator } from '@dreryk/react-components';

const StyledCommunicationWithP1Separator = styled(Separator)`
   margin-top: 24px;
   margin-bottom: 24px;
`;
StyledCommunicationWithP1Separator.displayName = 'StyledSeparator';

export { StyledCommunicationWithP1Separator };
